// Make a loose assumption that if we get a touch event we're on a device
// that's being scrolled primarily with touch. Possible for touch & mouse
// computers to scroll with touch and then go back, but lets not deal with
// that yet.
let touchScroll = false;
document.addEventListener('touchmove', () => {
    if (!touchScroll) {
        startTouchScrollMode();
    }
});

function startTouchScrollMode() {
    touchScroll = true;
    clearCssHover();
    document.addEventListener('scroll', animateInViewPort);
}

function clearCssHover() {
    const gifs = Array.from(document.getElementsByClassName('preview-overlap'));
    gifs.forEach((elem) => elem.classList.remove('show-on-hover'));
}

function animateInViewPort() {
    const windowCenter = window.innerHeight / 2;
    const gifs = Array.from(document.getElementsByClassName('preview-overlap'));
    gifs.forEach((elem) => elem.classList.remove('show'));

    var closestDist = Number.POSITIVE_INFINITY;
    var closestElems = [];
    for (const elem of gifs) {
        const boundingBox = elem.getBoundingClientRect();
        const elemCenter = (boundingBox.top + boundingBox.bottom) / 2;
        const dist = Math.abs(elemCenter - windowCenter);
        if (dist < closestDist) {
            closestDist = dist;
            closestElems = [elem];
        }
        else if (dist == closestDist) {
            closestElems.push(elem);
        }
    }
    closestElems.forEach((elem) => elem.classList.add('show'));
}


// WEBPACK FOOTER //
// ./js/main.js